import React, { forwardRef } from 'react';
import cm from 'classnames';
import styles from './_track-clip.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  modifiers: {
    menuActive?: boolean;
    outOfRange?: boolean;
    boundary?: boolean;
    editing?: boolean;
    error?: boolean;
    empty?: boolean;
    active?: boolean;
    selected?: boolean;
    cannotDrop?: boolean;
    draggedOver?: boolean;
  };
}

export const ClipContainer = forwardRef<HTMLDivElement, Props>(
  ({ modifiers, className, children, ...rest }: Props, ref) => {
    return (
      <div
        {...rest}
        ref={ref}
        className={cm(styles.ClipContainer, className, {
          [styles['ClipContainer--boundary']]: modifiers.boundary,
          [styles['ClipContainer--selected']]: modifiers.selected,
          [styles['ClipContainer--active']]: modifiers.active,
          [styles['ClipContainer--error']]: modifiers.error,
          [styles['ClipContainer--empty']]: modifiers.empty,
          [styles['ClipContainer--editing']]: modifiers.editing,
          [styles['ClipContainer--cannotDrop']]: modifiers.cannotDrop,
          [styles['ClipContainer--menuActive']]: modifiers.menuActive,
          [styles['ClipContainer--outOfRange']]: modifiers.outOfRange,
          [styles['ClipContainer--draggedOver']]: modifiers.draggedOver,
        })}
      >
        {children}
      </div>
    );
  }
);
